<template>
    <div class="wrap">
        <div>
            <Banner></Banner>
        </div>
        <div class="title">
            <div class="info">
                {{hospital}}-{{name}}
            </div>
            <div class="exit" @click="toExit">
                <a  href="javascript:void(0);">退出</a>
            </div>
        </div>
        <div class="content">
            <div class="btn">
                    <div class="item">
                        <div v-if="phase==1" @click="toLearner">
                            <img  src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_1.png">
                        </div>
                        <div v-else>
                            <img  src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_3.png">
                        </div>
                    </div>
                    <div class="item">
                        <div v-if="phase==1">
                            <img  src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_2.png">
                        </div>
                        <div v-else @click="toStar">
                            <img  src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_4.png">
                        </div>
                    </div>
            </div>
        </div>
        <div class="bottom">
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bottom_1.png">
        </div>
    </div>
</template>

<script>
    import {ksdPhase,exit} from "@/assets/js/api";
    import Banner from "@/components/ksd/fragment/Banner";
    import {isMobile} from "../../../assets/util/util";
    import {MessageBox} from "mint-ui";

    export default {
        name: "RepToken",
        components:{
            Banner
        },
        data(){
            return{
                rule:"查看活动规则",
                leaner:"达标学者",
                star:"达标之星",
                docId:this.$store.state.ksd_docId,
                phase:1,
                hospital:"北京协和医院",
                name:"张三",
            }
        },
        methods:{
            toStar(){
                // this.$toast("活动已结束")
                this.$router.push({path:"./docStar"})
            },
            toLearner(){
                // this.$toast("活动已结束")
                this.$router.push({path:"./docLearner"})
            },
            async getPhase(docId){
                const res = await ksdPhase({docId})
                this.phase = res.data.data.phase
                this.name = res.data.data.name
                this.hospital = res.data.data.hos
            },
            toExit(){
                let _this =this
                MessageBox({
                    title: '',
                    message: "是否确认退出",
                    showCancelButton: false
                }).then(() => {
                   _this.exitSubmimt();
                });
            },
            async exitSubmimt(){
                let docId = this.docId
                const res = await exit({docId})
                if(res.data.success){
                    this.$toast("退出成功")
                    if(isMobile()){//移动端重定向，把code带回来
                        let url = "http://app.iumed.com.cn/docLogin"
                        window.location.replace("http://tang.iumed.com.cn?url="+url)
                    }else{
                        this.$router.replace("docLogin")
                    }
                }
            }
        },
        mounted(){
            this.getPhase(this.docId)
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: hidden;
    }
    .content{
        display: flex;
        align-items: center;
    }

    .bottom{
        flex-grow: 1;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        img{
            width: 70%;
            object-fit: contain;
        }
    }
    .rule{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding-right: 30px;
        align-items: center;
        align-items: center;
        span{
            display: block;
            width: 16px;
            height: 16px;
            background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/question.png")  no-repeat ;
            background-size: contain;
            margin: 0 5px;
        }
    }
    .btn{
        width: 80%;
        display: flex;
        flex-flow: row;
        justify-content: space-around;
        margin: 8px auto;
    }
    .btn .item{
        width: 100px;
        height: 100px;
        border-radius: 5px;
        position: relative;
    }
    .btn .item{
        img{
            width: 113px;
            height: 100px;
        }
    }

    .title{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin: 5px 20px;
        font-size: 16px;
    }

</style>
